import React from "react";
import AddContent from "../components/pages/Content/AddContent";
import SideNav from "../components/SideNav/sideNav";
import Header from "../components/Header/hearder";
import { Wrapper } from "./layout.styles";

const CourseCreationLayout = () => {
  return (
    <React.Fragment>
      <Header />
      <Wrapper>
        <SideNav />
        <div style={{ margin: "70px 0px 0px 200px", width: "100%" }}>
          <AddContent />
        </div>
      </Wrapper>
    </React.Fragment>
  );
};

export default CourseCreationLayout;
